import React from "react";
import PricingCard from "../../cards/pricingCard";
import Badge from "../../shared/badge";
import { Icon } from "@iconify/react";
import Button from "../../shared/button";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const Pricing = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="w-full bg-white py-[90px] sm-s:py-[20px]" id="pricing ">
      <div className="flex flex-col lg:flex-row items-center gap-[20px] justify-between w-[80%] max-xxxl:w-[90%] m-auto py-[46px] pb-[96px]">
        <div className="w-full lg:w-1/2">
          <Badge txt={t("home.pricing.title")} />
          <h2 className="max-w-[528px] leading-[70px] tracking-[-3px] font-sora">
            {t("home.pricing.subtitle")}
          </h2>
          <p className="large txt-color tracking-[-0.72px] font-manrope mt-[25px] max-w-[563px]">
            The legal profession is changing faster than ever. Whether you're an
            independent lawyer building your practice or a prestigious firm
            looking to grow further, every day brings new challenges and
            opportunities. We've walked in your shoes and know exactly what
            you're up against:
            <ul className="list-disc list-inside mt-[20px] px-[10px]">
              <li>Growing competition in the legal market</li>
              <li>Increasing client expectations</li>
              <li>The pressure to adopt new technologies</li>
              <li>The need to expand your practice's reach</li>
            </ul>
          </p>
          <Button
            text="Go to Pricing Section"
            className="button btn-secondary mt-[35px]"
            height={50}
            width={180}
            onClick={() => navigate("/pricing")}
          />
        </div>
        <div className="w-full lg:w-1/2 flex justify-center items-center">
          <img src="../../assets/images/home/pricing-main.png" alt="" />
        </div>
      </div>
    </div>
  );
};

export default Pricing;
